import { getProfitSettings } from 'api/v2/taxes';
import useQuery from 'hooks/react-query/useQuery';

const useProfitMeta = () => {
  return useQuery('PROFIT_CALCULATIONS', getProfitSettings, {
    gcTime: 0,
  });
};

export default useProfitMeta;
